import { render, staticRenderFns } from "./explain-results-aside-result-card.component.vue?vue&type=template&id=2971acf6&scoped=true"
import script from "./explain-results-aside-result-card.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-aside-result-card.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-aside-result-card.component.vue?vue&type=style&index=0&id=2971acf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971acf6",
  null
  
)

export default component.exports